import React from 'react'
import { PropTypes } from 'prop-types'
import { trackGtmEvent } from '../../util/tracking'

const WertErmittlerModalButton = ({ openModal, buttonTitle }) => {
  const title = buttonTitle ? buttonTitle : 'Wertermittler öffnen'

  const wertermittlerClick = event => {
    trackGtmEvent('wertermittler-global-start')
    if (typeof window !== 'undefined') {
      window.__ksk001WertermittlerOpener =
        (event && event.currentTarget) || null
    }
    openModal()
  }

  return (
    <button
      type="button"
      onClick={wertermittlerClick}
      className="btn btn--primary has-icon wertermittler-modal-button"
      icon="true"
      aria-label={title}
    >
      {title}
      <div className="button-icon" />
    </button>
  )
}

WertErmittlerModalButton.propTypes = {
  openModal: PropTypes.func,
  buttonTitle: PropTypes.string,
}

export default WertErmittlerModalButton
